module.exports = __webpack_public_path__ + "static/media/ipad-6.7a3932ef.jpg";